export default "__VITE_ASSET__D8Lz6M4X__"